/**
 * Theme: Hyper - Responsive Bootstrap 4 Admin Dashboard
 * Author: Coderthemes
 * Module/App: Main Js
 */
"use strict";

!function ($) {
    "use strict";

    /**
    Portlet Widget
    */
    var Portlet = function () {
        this.$body = $("body"),
            this.$portletIdentifier = ".card",
            this.$portletCloser = '.card a[data-toggle="remove"]',
            this.$portletRefresher = '.card a[data-toggle="reload"]'
    };


    //Apex chart all product hamburger icon out click close
    $(".reportPage").click(function(){
        if($('.apexcharts-menu').hasClass('apexcharts-menu-open')) {
            $('.apexcharts-menu').removeClass('apexcharts-menu-open')
        }
    });

    //on init
    Portlet.prototype.init = function () {

        $( ".draggable" ).draggable();

        // Panel closest
        var $this = this;
        $(document).on("click", this.$portletCloser, function (ev) {
            ev.preventDefault();
            var $portlet = $(this).closest($this.$portletIdentifier);
            var $portlet_parent = $portlet.parent();
            $portlet.remove();
            if ($portlet_parent.children().length == 0) {
                $portlet_parent.remove();
            }
        });

        // Panel Reload
        $(document).on("click", this.$portletRefresher, function (ev) {
            ev.preventDefault();
            var $portlet = $(this).closest($this.$portletIdentifier);
            // This is just a simulation, nothing is going to be reloaded
            $portlet.append('<div class="card-disabled"><div class="card-portlets-loader"></div></div>');
            var $pd = $portlet.find('.card-disabled');
            setTimeout(function () {
                $pd.fadeOut('fast', function () {
                    $pd.remove();
                });
            }, 500 + 300 * (Math.random() * 5));
        });
    },
        //
        $.Portlet = new Portlet, $.Portlet.Constructor = Portlet

}(window.jQuery),

function ($) {
    'use strict';

    var AdvanceFormApp = function () {
        this.$body = $('body'),
            this.$window = $(window)
    };

    /** 
     * Initlizes the select2
    */
    AdvanceFormApp.prototype.initSelect2 = function () {

        // Select2
        var select2 = $('[data-toggle="select2"]');

        
        if (select2.length) {
            select2.each(function (index, element) {
                $(this).select2({
                    language: $("html").attr("lang")
                });
            });
        }

        select2.on("select2:close", function (e) {
            if ($(this).closest(".form").length) {
                $(this).valid();
            }
        });

        select2.on("change.select2", function (e) {
            if ($(this).val() === '' || $(this).val() === ' ' || $(this).val() === null) {
                $(this).addClass("select-place-holder");
            } else {
                $(this).removeClass("select-place-holder");
            }
        });

        select2.each(function (index, element) {
            if ($(this).val() === '' || $(this).val() === ' ' || $(this).val() === null) {
                $(this).addClass("select-place-holder");
            } else {
                $(this).removeClass("select-place-holder");
            }
        });

        // Select App
        var selectApp = $(".select-app");
        var selectAppDropDownClass = "";

        if (selectApp.hasClass("select-app-large")) {
            selectAppDropDownClass = "select-app-dropdown select-app-dropdown-large";
        } else {
            selectAppDropDownClass = "select-app-dropdown";
        }

        function templateResult(state) {
            if (!state.id) {
                return state.text;
            }
            var flagName = state.text.replace(/ /g, "-").toLowerCase();
            flagName = flagName.replace(",", "-").toLowerCase();
            var dataPath = state.element.getAttribute("data-img-path");
            if (dataPath) {
                var baseUrl = dataPath;
            } else {
                var baseUrl = "";
            }
            if (baseUrl) {
                var $state = $(
                    '<span class="select-app-logo-wrapper"><img src="' + baseUrl + '" class="select-app-logo" width="32" height="32" /> <em>' + state.text + '</em></span>'
                );
            } else {
                var $state = $(
                    '<span class="select-app-logo-wrapper">' + state.text + '</span>'
                );
            }
            return $state;
        };

        function templateSelection(state) {
            if (!state.id) {
                return state.text;
            }
            var flagName = state.text.replace(/ /g, "-").toLowerCase();
            flagName = flagName.replace(",", "-").toLowerCase();
            var dataPath = state.element.getAttribute("data-img-path");
            if (dataPath) {
                var baseUrl = dataPath;
            } else {
                var baseUrl = "";
            }
            if (baseUrl) {
                var $state = $(
                    '<span class="select-app-logo-wrapper"><img src="' + baseUrl + '" class="select-app-logo" width="32" height="32" /> <em>' + state.text + '</em></span>'
                );
            } else {
                var $state = $(
                    '<span class="select-app-logo-wrapper">' + state.text + '</span>'
                );
            }
            return $state;
        };

        if (selectApp.length) {
            selectApp.each(function(i,e) {
                $(e).select2({
                    language: $("html").attr("lang"),
                    templateResult: templateResult,
                    templateSelection: templateSelection
                }).data('select2').$dropdown.addClass(selectAppDropDownClass); 
            })
        }

        selectApp.on("select2:close", function (e) {

        });

        selectApp.on("change.select2", function (e) {
            if ($(this).val() === '' || $(this).val() === ' ' || $(this).val() === null) {
                $(this).addClass("select-place-holder");
            } else {
                $(this).removeClass("select-place-holder");
            }
        });

        selectApp.each(function (index, element) {
            if ($(this).val() === '' || $(this).val() === ' ' || $(this).val() === null) {
                $(this).addClass("select-place-holder");
            } else {
                $(this).removeClass("select-place-holder");
            }
        });
    },

        /** 
         * Initlized mask
        */
        AdvanceFormApp.prototype.initMask = function () {
            $('[data-toggle="input-mask"]').each(function (idx, obj) {
                var maskFormat = $(obj).data("maskFormat");
                var reverse = $(obj).data("reverse");
                if (reverse != null)
                    $(obj).mask(maskFormat, { 'reverse': reverse });
                else
                    $(obj).mask(maskFormat);
            });
        },

        // Datetime and date range picker
        AdvanceFormApp.prototype.initDateRange = function () {
            var defaultOptions = {
                "cancelClass": "btn-light",
                "applyButtonClasses": "btn-success"
            };

            // date pickers
            $('[data-toggle="date-picker"]').each(function (idx, obj) {
                var objOptions = $.extend({}, defaultOptions, $(obj).data());
                $(obj).daterangepicker(objOptions);
            });

            //date pickers ranges only
            var start = moment().subtract(29, 'days');
            var end = moment();
            var defaultRangeOptions = {
                startDate: start,
                endDate: end,
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                }
            };

            $('[data-toggle="date-picker-range"]').each(function (idx, obj) {
                var objOptions = $.extend({}, defaultRangeOptions, $(obj).data());
                var target = objOptions["targetDisplay"];
                //rendering
                $(obj).daterangepicker(objOptions, function (start, end) {
                    if (target)
                        $(target).html(start.format('YYYY-MM-DD') + ', ' + end.format('YYYY-MM-DD'));
                    if ($(".range_date #selectedTitle")) {
                        if ($(this)[0]["chosenLabel"] == 'Custom Range') {
                            $(".range_date #selectedTitle").html(start.format('YYYY-MM-DD') + ', ' + end.format('YYYY-MM-DD'));
                        } else {
                            $(".range_date #selectedTitle").html($(this)[0]["chosenLabel"]);
                        }
                    }
                });
            });

            setTimeout(function () {
                $(document).on('click', '[data-toggle="date-picker-range"]', function(e) {
                    if($("#selectedValue").html().length == 0) {
                        $(".daterangepicker .ranges ul li").removeClass("active");
                        $(".daterangepicker .date-range-all-date").addClass("active");
                    } else {
                        $(".daterangepicker .date-range-all-date").removeClass("active");
                    }
                });
                $(document).on('click', '.daterangepicker .date-range-all-date', function(e) {
                    e.preventDefault();
                    $(this).closest(".ranges").find("li").removeClass("active");
                    $(this).addClass("active");
                    localStorage.removeItem("tickets-date-range");
                    localStorage.removeItem("tickets-date-title");
                    localStorage.setItem('chart-date', "All-Date-" + moment().format('DD-MMM-YYYY'))
                    localStorage.setItem('report-all-date', true)
                    location.reload();
                });
                $('[data-toggle="date-picker-range"]').on('apply.daterangepicker', function(ev, picker) {
                    //$(".daterangepicker .date-range-all-date").removeClass("active");
                    if($("#selectedValue").html().length != 0) { 
                        $(".daterangepicker .date-range-all-date").removeClass("active");
                    }
                });
            }, 700);

        },

        // time picker
        AdvanceFormApp.prototype.initTimePicker = function () {
            var defaultOptions = {
                "showSeconds": true,
                "icons": {
                    "up": "mdi mdi-chevron-up",
                    "down": "mdi mdi-chevron-down"
                }
            };

            // time picker
            $('[data-toggle="timepicker"]').each(function (idx, obj) {
                var objOptions = $.extend({}, defaultOptions, $(obj).data());
                $(obj).timepicker(objOptions);
            });
        },

        // touchspin
        AdvanceFormApp.prototype.initTouchspin = function () {
            var defaultOptions = {
            };

            // touchspin
            $('[data-toggle="touchspin"]').each(function (idx, obj) {
                var objOptions = $.extend({}, defaultOptions, $(obj).data());
                $(obj).TouchSpin(objOptions);
            });
        },

        // maxlength
        AdvanceFormApp.prototype.initMaxlength = function () {
            var defaultOptions = {
                warningClass: "badge badge-success",
                limitReachedClass: "badge badge-danger",
                separator: ' out of ',
                preText: 'You typed ',
                postText: ' chars available.',
                placement: 'bottom',
            };

            // maxlength
            $('[data-toggle="maxlength"]').each(function (idx, obj) {
                var objOptions = $.extend({}, defaultOptions, $(obj).data());
                $(obj).maxlength(objOptions);
            });
        },

        /** 
         * Initilize
        */
        AdvanceFormApp.prototype.init = function () {
            var $this = this;
            this.initSelect2();
            this.initMask();
            this.initDateRange();
            this.initTimePicker();
            this.initTouchspin();
            this.initMaxlength();
        },

        $.AdvanceFormApp = new AdvanceFormApp, $.AdvanceFormApp.Constructor = AdvanceFormApp


}(window.jQuery),

function ($) {
    'use strict';

    var NotificationApp = function () {
    };


    /**
     * Send Notification
     * @param {*} heading heading text
     * @param {*} body body text
     * @param {*} position position e.g top-right, top-left, bottom-left, etc
     * @param {*} loaderBgColor loader background color
     * @param {*} icon icon which needs to be displayed
     * @param {*} hideAfter automatically hide after seconds
     * @param {*} stack 
     */
    NotificationApp.prototype.send = function (heading, body, position, loaderBgColor, icon, hideAfter, stack, showHideTransition) {
        // default      
        if (!hideAfter)
            hideAfter = 3000;
        if (!stack)
            stack = 1;

        var options = {
            heading: heading,
            text: body,
            position: position,
            loaderBg: loaderBgColor,
            icon: icon,
            hideAfter: hideAfter,
            stack: stack
        };

        if (showHideTransition)
            options.showHideTransition = showHideTransition;
        else
            options.showHideTransition = 'fade';

        $.toast().reset('all');
        $.toast(options);
    },

        $.NotificationApp = new NotificationApp, $.NotificationApp.Constructor = NotificationApp

}(window.jQuery),

function ($) {
    "use strict";

    var Components = function () { };


    //initializing tooltip
    Components.prototype.initTooltipPlugin = function () {
        $.fn.tooltip && $('[data-toggle="tooltip"]').tooltip()
    },

        //initializing popover
        Components.prototype.initPopoverPlugin = function () {
            $.fn.popover && $('[data-toggle="popover"]').popover()
        },

        //initializing toast
        Components.prototype.initToastPlugin = function () {
            $.fn.toast && $('[data-toggle="toast"]').toast()
        },

        //initializing Slimscroll
        Components.prototype.initSlimScrollPlugin = function () {
            //You can change the color of scroll bar here
            if ($(".slimscroll").hasClass("slimscroll-bottom")) {
                var startSlimscroll = 'bottom';
            } else {
                var startSlimscroll = 'top';
            }
            $.fn.slimScroll && $(".slimscroll").slimScroll({
                height: 'auto',
                position: 'right',
                size: "8px",
                start: startSlimscroll,
                touchScrollStep: 20,
                color: '#9ea5ab'
            });
        },

        //initializing form validation
        Components.prototype.initFormValidation = function () {
            $(".needs-validation").on('submit', function (event) {
                $(this).addClass('was-validated');
                if ($(this)[0].checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                }
                return true;
            });
        },


        //initilizing
        Components.prototype.init = function () {
            var $this = this;
            this.initTooltipPlugin(),
                this.initPopoverPlugin(),
                this.initToastPlugin(),
                this.initSlimScrollPlugin(),
                this.initFormValidation();
        },

        $.Components = new Components, $.Components.Constructor = Components

}(window.jQuery),

function ($) {
    'use strict';

    var App = function () {
        this.$body = $('body'),
            this.$window = $(window)
    };

    /**
    Resets the scroll
        */
    App.prototype._resetSidebarScroll = function () {
        // sidebar - scroll container
        $('.slimscroll-menu').slimscroll({
            height: 'auto',
            position: 'right',
            size: "8px",
            color: '#9ea5ab',
            wheelStep: 5,
            touchScrollStep: 20
        });
    },
        /** 
         * Initlizes the menu - top and sidebar
        */
        App.prototype.initMenu = function () {
            var $this = this;

            // Left menu collapse
            $('.button-menu-mobile').on('click', function (event) {
                event.preventDefault();
                $this.$body.toggleClass('sidebar-enable');
                if ($this.$window.width() >= 768) {
                    $this.$body.toggleClass('enlarged');
                } else {
                    $this.$body.removeClass('enlarged');
                }

                // sidebar - scroll container
                $this._resetSidebarScroll();
            });
            $('.close-matismenu').on('click', function (event) {
                event.preventDefault();
                $('.button-menu-mobile').trigger("click")
            });

            // sidebar - main menu
            $(".side-nav").metisMenu();

            // remove slim scroll if scrollable sidebar
            if (this.$body.hasClass("scrollable-layout"))
                $("#left-side-menu-container").removeClass("slimscroll-menu");

            // sidebar - scroll container
            $this._resetSidebarScroll();

            // right side-bar toggle
            $('.right-bar-toggle').on('click', function (e) {
                $('body').toggleClass('right-bar-enabled');
            });

            $(document).on('click', 'body', function (e) {
                if ($(e.target).closest('.right-bar-toggle, .right-bar').length > 0) {
                    return;
                }

                if ($(e.target).closest('.left-side-menu, .side-nav').length > 0 || $(e.target).hasClass('button-menu-mobile')
                    || $(e.target).closest('.button-menu-mobile').length > 0) {
                    return;
                }

                $('body').removeClass('right-bar-enabled');
                $('body').removeClass('sidebar-enable');
                return;
            });

            // activate the menu in left side bar based on url
            $(".side-nav a").each(function () {
                var pageUrl = window.location.href.split(/[?#]/)[0];
                if (this.href == pageUrl) {
                    $(this).addClass("active");
                    $(this).parent().addClass("active"); // add active to li of the current link
                    $(this).parent().parent().addClass("in");
                    $(this).parent().parent().prev().addClass("active"); // add active class to an anchor
                    $(this).parent().parent().parent().addClass("active");
                    $(this).parent().parent().parent().parent().addClass("in"); // add active to li of the current link
                    $(this).parent().parent().parent().parent().parent().addClass("active");
                }
            });

            $(".topnav-menu li a").each(function () {
                var pageUrl = window.location.href.split(/[?#]/)[0];
                if (this.href == pageUrl) {
                    $(this).addClass("active");
                    $(this).parent().parent().addClass("active"); // add active to li of the current link
                    $(this).parent().parent().parent().parent().addClass("active");
                }
            });

            // Topbar - main menu
            $('.navbar-toggle').on('click', function (event) {
                $(this).toggleClass('open');
                $('#navigation').slideToggle(400);
            });

            //
            $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
                if (!$(this).next().hasClass('show')) {
                    $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
                }
                var $subMenu = $(this).next(".dropdown-menu");
                $subMenu.toggleClass('show');

                return false;
            });

            // macro search
            if ($(".macro-search")) {
                $(".macro-search .search-input").on('keyup', function () {
                    var value = $(this).val().toLowerCase();
                    $(".macro-item").filter(function () {
                        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
                    });
                });
            }

            // read upload 
            function readURL(input) {
                for (var i = 0; i < input.files.length; i++) {
                    if (input.files[i]) {
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            var img = $('<img>');
                            if (e.target.result) {
                                img.attr('src', e.target.result);
                            } else {
                                img.attr('src', "/assets/images/projects/project-default.jpg");
                            }
                            img.appendTo($("#" + input.id).closest(".custom-file").prev(".custom-file-preview"));
                        }
                        reader.readAsDataURL(input.files[i]);
                    }
                }
            }
            // custom-file-input
            $(".custom-file-input").each(function (index, element) {
                if ($(this)) {

                    if ($(this).hasClass("custom-file-avatar") == true) { // avatar 

                        var defaultAvatar = $(this).closest(".avatar-upload").find(".custom-file-preview").html();
                        $(this).change(function () {
                            if (this.files.length > 0) {
                                var filename = this.files[0].name;
                                if (filename) {
                                    $(this).closest(".avatar-upload").find(".custom-file-preview").html("");
                                    $(this).closest(".avatar-upload").find("label.custom-file-label").hide();
                                    $(this).closest(".avatar-upload").find(".custom-file-label").show();
                                    $(this).closest(".avatar-upload").removeClass("avatar-upload-active");
                                    readURL(this);
                                }
                            } else {
                                $(this).closest(".avatar-upload").find(".custom-file-preview").html(defaultAvatar);
                                $(this).closest(".avatar-upload").find("label.custom-file-label").show();
                                $(this).closest(".avatar-upload").find(".custom-file-label").hide();
                                $(this).closest(".avatar-upload").addClass("icon-upload-active");
                            }
                        });

                    }

                    else if ($(this).hasClass("custom-file-icon") == true) { // icon 

                        var defaultIcon = $(this).closest(".icon-upload").find(".custom-file-preview").html();
                        $(this).change(function () {
                            if (this.files.length > 0) {
                                var filename = this.files[0].name;
                                if (filename) {
                                    $(this).closest(".icon-upload").find(".custom-file-preview").html("");
                                    $(this).closest(".icon-upload").find("label.custom-file-label").hide();
                                    $(this).closest(".icon-upload").find(".custom-file-label").show();
                                    $(this).closest(".icon-upload").removeClass("icon-upload-active");
                                    readURL(this);
                                }
                            } else {
                                $(this).closest(".icon-upload").find(".custom-file-preview").html(defaultIcon);
                                $(this).closest(".icon-upload").find("label.custom-file-label").show();
                                $(this).closest(".icon-upload").find(".custom-file-label").hide();
                                $(this).closest(".icon-upload").addClass("icon-upload-active");
                            }
                        });

                    }

                    else if ($(this).hasClass("custom-file-logo") == true) { // logo 

                        var defaultLogo = $(this).closest(".logo-upload").find(".custom-file-preview").html();
                        $(this).change(function () {
                            if (this.files.length > 0) {
                                var filename = this.files[0].name;
                                if (filename) {
                                    $(this).closest(".logo-upload").find(".custom-file-preview").html("");
                                    $(this).closest(".logo-upload").find(".custom-file-label").show();
                                    $(this).closest(".logo-upload").removeClass("logo-upload-active");
                                    readURL(this);
                                }
                            } else {
                                $(this).closest(".logo-upload").find(".custom-file-preview").html(defaultLogo);
                                $(this).closest(".logo-upload").find("label.custom-file-label").show();
                                $(this).closest(".logo-upload").addClass("logo-upload-active");
                            }
                        });

                    }

                    else { //default

                        var filenameLabel = $(this).next(".custom-file-label").text();
                        $(this).change(function () {
                            if (this.files.length > 0) {
                                var filename = this.files[0].name
                                if (filename) {
                                    $(this).next(".custom-file-label").text(filename);
                                }
                            } else {
                                $(this).next(".custom-file-label").text(filenameLabel);
                            }
                        });

                    }
                }
            });

            // copy text
            $(".copy-button").click(function (e) {
                e.preventDefault();
                var $this = $(this);
                $this.closest(".copy-code-wrapper").find(".copy-textarea").select();
                document.execCommand('copy');
                $this.find(".copy").hide();
                $this.find(".copied").css("display", "inline-block");
                setTimeout(function () {
                    $this.find(".copied").hide();
                    $this.find(".copy").css("display", "inline-block");
                }, 1000);
            });

            // copy text
            $(".copy-text-button").click(function (e) {
                e.preventDefault();
                var $this = $(this);
                $this.closest(".copy-text").find(".copy-text-value").select();
                document.execCommand('copy');
                $this.find(".copy").hide();
                $this.find(".copied").css("display", "inline-block");
                setTimeout(function () {
                    $this.find(".copied").hide();
                    $this.find(".copy").css("display", "inline-block");
                }, 1000);
            });

            // app search
            if ($(".filter-search-app")) {
                $(".filter-search-app").on('keyup', function () {
                    var value = $(this).val().toLowerCase();
                    $(".application-list .al-row .alr-cell").filter(function () {
                        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
                    });
                });
            }

        },

        /** 
         * Init the layout - with broad sidebar or compact side bar
        */
        App.prototype.initLayout = function () {
            // in case of small size, add class enlarge to have minimal menu
            if (this.$window.width() >= 768 && this.$window.width() <= 1028) {
                this.$body.addClass('enlarged');
            } else {
                if (this.$body.data('keep-enlarged') != true) {
                    //this.$body.removeClass('enlarged');
                }
            }
        },

        //initilizing
        App.prototype.init = function () {
            var $this = this;
            this.initLayout();
            this.initMenu();
            //creating portles
            $.Portlet.init();
            $.AdvanceFormApp.init();
            $.Components.init();

            // on window resize, make menu flipped automatically
            $this.$window.on('resize', function (e) {
                e.preventDefault();
                $this.initLayout();
                $this._resetSidebarScroll();
            });
        },

        $.App = new App, $.App.Constructor = App


}(window.jQuery),

//initializing main application module
function ($) {
    "use strict";
    $.App.init();
}(window.jQuery);

var Desk360 = Desk360 || {};

Desk360.Main = function ($) {
    "use strict";

    // showDialogFN function
    var showDialogFN = function showDialogFN(options) {

        var settings = $.extend({
            id: "modalDialog",
            confirm: true,
            center: false,
            close: false,
            overleyClick: false,
            buttonHide: false,
            scroll: false,
            size: "",
            title: "",
            message: "-",
            buttonCustom: "",
            buttonYesText: "Yes",
            buttonNoText: "No",
            buttonOkText: "Ok",
            buttonYesClass: "btn btn-primary",
            buttonNoClass: "btn btn-secondary",
            buttonOkClass: "btn btn-primary",
            yes: function () { },
            no: function () { },
            okey: function () { }
        }, options);

        var modalClickYes = false;
        var modalClickNo = false;
        var modalClickOk = false;
        var modalOverlayClick = "";
        var modalSize = "";
        var modalCenter = "";
        var modalHtml = "";

        if (settings.size) {
            var modalSize = "modal-" + settings.size;
        }
        if (settings.center == true) {
            var modalCenter = "modal-dialog-centered";
        }
        if (settings.scroll == true) {
            var modalScroll = "modal-dialog-scrollable";
        }

        if (settings.overleyClick == false) {
            var modalOverlayClick = 'data-backdrop="static"';
        }

        modalHtml = '<!-- modal -->';
        modalHtml += '<div class="modal fade dialog-modal" tabindex="-1" role="dialog" aria-hidden="true" id="' + settings.id + '" ' + modalOverlayClick + '>';

        modalHtml += '<div class="modal-dialog ' + modalScroll + ' ' + modalCenter + ' ' + modalSize + '">';
        modalHtml += '<div class="modal-content">';

        if (settings.title) {
            modalHtml += '<!-- modal header-->';
            modalHtml += '<div class="modal-header">';
            modalHtml += '<h4 class="modal-title">' + settings.title + '</h4>';
            if (settings.close == true) {
                modalHtml += '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>';
            }
            modalHtml += '</div>';
            modalHtml += '<!-- modal header end -->';
        }

        if (settings.message) {
            modalHtml += '<!-- modal body -->';
            modalHtml += '<div class="modal-body">';
            modalHtml += settings.message;
            modalHtml += ' </div>';
            modalHtml += '<!-- modal body end -->';
        }
         
        if (settings.buttonHide == false) {
            if (settings.buttonCustom) {
                modalHtml += '<!-- modal footer -->';
                modalHtml += '<div class="modal-footer">';
                modalHtml += settings.buttonCustom;
                modalHtml += '</div>';
                modalHtml += '<!-- modal footer end -->';
            } else {
                modalHtml += '<!-- modal footer -->';
                modalHtml += '<div class="modal-footer">';
                if (settings.confirm == true) {
                    modalHtml += '<a class="' + settings.buttonNoClass + '" href="javascript:;" data-dismiss="modal" id="' + settings.id + '_dialogModalNo" title="' + settings.buttonNoText + '">' + settings.buttonNoText + '</a>';
                    modalHtml += '<a class="' + settings.buttonYesClass + '" href="javascript:;" id="' + settings.id + '_dialogModalYes" title="' + settings.buttonYesText + '">' + settings.buttonYesText + '</a>';
                } else {
                    modalHtml += '<a class="' + settings.buttonOkClass + '" href="javascript:;" data-dismiss="modal" id="' + settings.id + '_dialogModalOk" title="' + settings.buttonOkText + '">' + settings.buttonOkText + '</a>';
                }
                modalHtml += '</div>';
                modalHtml += '<!-- modal footer end -->';
            }
        }

        modalHtml += '</div>';
        modalHtml += '</div>';
        modalHtml += '</div>';
        modalHtml += '<!-- modal end -->';


        $(".modal-backdrop").remove();
        $(".modal.dialog-modal").remove();
        $("body").append(modalHtml);
        setTimeout(function() {
            $(".modal.dialog-modal").modal();
        }, 200);
        $(".modal.dialog-modal").on('hidden.bs.modal', function () {

            $(this).remove();
            $(".modal-backdrop").remove();

            if (modalClickYes == true) {
                settings.yes();
            } else if (modalClickNo == true) {
                settings.no();
            } else if (modalClickOk == true) {
                settings.okey();
            } else {
                //settings.yes();
            }

        });

        $(".modal.dialog-modal").on("click", "#" + $(".modal.dialog-modal").attr("id") + "_dialogModalNo", function () {
            modalClickNo = true;
            $(this).closest(".modal.dialog-modal").modal('hide');
        });

        $(".modal.dialog-modal").on("click", "#" + $(".modal.dialog-modal").attr("id") + "_dialogModalYes", function () {
            modalClickYes = true;
            $(this).closest(".modal.dialog-modal").modal('hide');
        });

        $(".modal.dialog-modal").on("click", "#" + $(".modal.dialog-modal").attr("id") + "_dialogModalOk", function () {
            modalClickOk = true;
            $(this).closest(".modal.dialog-modal").modal('hide');
        });

    }
    // showDialogFN function end 

    // showOverlay function
	var showOverlayFN = function(message) {
		var options = {
			theme: "sk-bounce",
			message: message
		};
		HoldOn.open(options);
	};
	// showOverlay function end

	// closeOverlay function
	var closeOverlayFN = function() {
		HoldOn.close();
	};
    // closeOverlay function end
    
    var maskFN = function maskFN() {
        // card mask
        $(document).on('input keydown keypress keyup mousedown mouseup select contextmenu drop', '.mask-number', function (e) {
            var regex = /^[0-9\s]*$/;

            if (regex.test(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }

            e.target.value = e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
        }); // mask numeric

        $(document).on('input keydown keypress keyup mousedown mouseup select contextmenu drop', '.mask-numeric', function (e) {
            var regex = /^[0-9\s]*$/;

            if (regex.test(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }

            e.target.value = e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1').trim();
        });
        }; // maskFN function end 
    // init function

    var init = function init() {
        
        // validate defualt settings
		$.validator.setDefaults({
			errorElement: "span",
			errorClass: "error",
			validClass: "succes",
			errorPlacement: function (error, element) {
			    if (element.hasClass("custom-file-input")) { // inputfile
					error.insertAfter(element.closest(".custom-file"));
				} else if(element.hasClass("select2")) { // select2 
                    error.insertAfter(element.next(".select2"));
                } else if(element.hasClass("jscolor")) { // select2 
                    error.insertAfter(element.closest(".color-input"));
                } else if(element.hasClass("flex-form-row-input")) { // flex-form-row
                    error.insertAfter(element.closest(".flex-form-row"));
				} else {
					error.insertAfter(element);
				}
			}
		});

        // max size 
        $("form").each(function () {
			$(this).validate();
        });

        // max size 
		var message;
		if ($("html").attr("lang") == "tr") {
			message = "Dosya boyutu maksimum {0} mb olmalıdır.";
		} else {
			message = "File size must not exceed {0} mb.";
		}
		$.validator.addMethod("maxsize", function (value, element, param) {
			if (this.optional(element)) {
				return true;
			}
			if ($(element).attr("type") === "file") {
				if (element.files && element.files.length) {
					for (var i = 0; i < element.files.length; i++) {
						if (element.files[i].size > (1048576 * param)) {
							return false;
						}
					}
				}
			}
			return true;
        }, $.validator.format(message));

        // domain control
		var message;
		if ($("html").attr("lang") == "tr" || $("html").attr("lang") == "tr-TR") {
			message = "Lütfen geçerli bir alt alan adı giriniz.";
		} else {
			message = "Please enter a valid subdomain.";
		}
		$.validator.addMethod("subdomain", function (value, element, param) {
			var regex = new RegExp("^[a-zA-Z0-9\\-]*$");
			return regex.test(value);
        }, $.validator.format(message));
        
        // paramater control
		var message;
		if ($("html").attr("lang") == "tr" || $("html").attr("lang") == "tr-TR") {
			message = "Lütfen geçerli bir alt alan adı giriniz.";
		} else {
			message = "Please enter a valid paramater.";
		}
		$.validator.addMethod("paramater", function (value, element, param) {
			var regex = new RegExp("^[a-zA-Z0-9\\-_]*$");
			return regex.test(value);
		}, $.validator.format(message));
        
        // file type 
		if ($("html").attr("lang") == "tr") {
			message = "Lütfen geçerli uzantıya sahip bir değer giriniz. ({0})";
		} else {
			message = "Please enter a value with a valid extension. ({0})";
		}
		$.validator.addMethod("extension", function (value, element, param) {
			param = typeof param === "string" ? param.replace(/,/g, "|") : "png|jpe?g|gif";
			return this.optional(element) || value.match(new RegExp("\\.(" + param + ")$", "i"));
		}, $.validator.format(message));

        // popover remove
        $('body').on('click', function (e) {
            $('[data-toggle="popover"]').each(function () {
                if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                    $(this).popover('hide');
                }
            });
        });

        // slimscroll scroll remove popover
        $('.slimscroll').slimScroll().bind('slimscrolling', function (e, pos) {
            $(".message-text").each(function (index, element) {
                $(this).popover("hide");
            });
        });

        // firefox slimscroll scroll fix
        var match = window.navigator.userAgent.match(/Firefox\/([0-9]+)\./);
        if(match){
            var scrollBarWidth = (window.innerWidth-$(window).width());
            $(".slimscroll").mouseover(function () { 
               $("body").css({
                "overflow": "hidden",
                "padding-right": scrollBarWidth,
               });
            });
            $(".slimscroll").mouseout(function () { 
               $("body").css({
                "overflow": "visible",
                "padding-right": "",
               });
            });
        }

    }; // init function end

    return {
        ShowDialogFN: showDialogFN,
        ShowOverlayFN: showOverlayFN,
        CloseOverlayFN: closeOverlayFN,
        MaskFN: maskFN,
        Init: init
    };

}(jQuery);

$(function () {
    Desk360.Main.Init();
    Desk360.Main.MaskFN();
});

(function ($) {
    $.fn.serializeFormJSON = function () {

        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };
})(jQuery);